unit View.Modalidades.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls, UUtils,
  UHelperServer;

type
  TFViewModalidadesEdit = class(TForm)
    DataSource: TDatasource;
    btCancel: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbnome: TLabel;
    ednome: TDBEdit;
    lbpermite_prazo: TLabel;
    lbmodalidade_avista: TLabel;
    lbmodalidade_cheque_vinculado: TLabel;
    lbmodalidade_prazo_fixo: TLabel;
    lbmodalidade_pagamento_digital: TLabel;
    lbmodalidade_pix: TLabel;
    lbmodalidade_cartao: TLabel;
    lbtipo_cartao: TLabel;
    edtipo_cartao: TDBEdit;
    lbcomissao: TLabel;
    edcomissao: TDBEdit;
    lbprazo_dias: TLabel;
    edprazo_dias: TDBEdit;
    lbdia_fixo: TLabel;
    eddia_fixo: TDBEdit;
    lbparcela_minima: TLabel;
    edparcela_minima: TDBEdit;
    lbquantidade_parcelas: TLabel;
    edquantidade_parcelas: TDBEdit;
    lbtag_pagamento: TLabel;
    edtag_pagamento: TDBEdit;
    lbcodigo_interno: TLabel;
    edcodigo_interno: TDBEdit;
    lbexcluido: TLabel;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientModalidadesGet: TXDataWebClient;
    ModalidadesDataset: TXDataWebDataSet;
    ModalidadesDatasetid: TIntegerField;
    ModalidadesDatasetaliado_id: TIntegerField;
    ModalidadesDatasetdata_base_id: TIntegerField;
    ModalidadesDatasetconta_id: TIntegerField;
    ModalidadesDatasetnome: TStringField;
    ModalidadesDatasetpermite_prazo: TBooleanField;
    ModalidadesDatasetmodalidade_avista: TBooleanField;
    ModalidadesDatasetmodalidade_cheque_vinculado: TBooleanField;
    ModalidadesDatasetmodalidade_prazo_fixo: TBooleanField;
    ModalidadesDatasetmodalidade_pagamento_digital: TBooleanField;
    ModalidadesDatasetmodalidade_pix: TBooleanField;
    ModalidadesDatasetmodalidade_cartao: TBooleanField;
    ModalidadesDatasettipo_cartao: TIntegerField;
    ModalidadesDatasetcomissao: TFloatField;
    ModalidadesDatasetprazo_dias: TIntegerField;
    ModalidadesDatasetdia_fixo: TIntegerField;
    ModalidadesDatasetparcela_minima: TFloatField;
    ModalidadesDatasetquantidade_parcelas: TIntegerField;
    ModalidadesDatasettag_pagamento: TStringField;
    ModalidadesDatasetcodigo_interno: TIntegerField;
    ModalidadesDatasetexcluido: TBooleanField;
    ModalidadesDatasetinclusao: TDateTimeField;
    ModalidadesDatasetalteracao: TDateTimeField;
    ModalidadesDatasetexclusao: TDateTimeField;
    pnlDadosModalidade: TPanel;
    cbxpermite_prazo: TDBCheckBox;
    cbxmodalidade_avista: TDBCheckBox;
    cbxmodalidade_cheque_vinculado: TDBCheckBox;
    cbxmodalidade_prazo_fixo: TDBCheckBox;
    cbxmodalidade_pagamento_digital: TDBCheckBox;
    modalidade_pix: TDBCheckBox;
    cbxmodalidade_cartao: TDBCheckBox;
    cbxexcluido: TDBCheckBox;
    lbapi_pix_id: TLabel;
    lbapi_pix_codigo_interno: TLabel;
    lbclient_id: TLabel;
    lbclient_secret: TLabel;
    lbdeveloper_key: TLabel;
    lbapi_pix_excluido: TLabel;
    lbapi_pix_inclusao: TLabel;
    lbapi_pix_alteracao: TLabel;
    lbapi_pix_exclusao: TLabel;
    pnlDadosSincronizacaoAutomatica: TPanel;
    edapi_pix_id: TDBEdit;
    edapi_pix_codigo_interno: TDBEdit;
    edclient_id: TDBEdit;
    edclient_secret: TDBEdit;
    eddeveloper_key: TDBEdit;
    cbxapi_pix_excluido: TDBCheckBox;
    edapi_pix_inclusao: TDBEdit;
    edapi_pix_alteracao: TDBEdit;
    edapi_pix_exclusao: TDBEdit;
    btnBaixarChavePrivada: TButton;
    btnBaixarCertificadoPem: TButton;
    XDataWebClientBaixarArquivos: TXDataWebClient;
    lbchave_pix: TLabel;
    edchave_pix: TDBEdit;
    btnCopiarChavePix: TButton;
    ModalidadesDatasetapi_pixcodigo_interno: TIntegerField;
    ModalidadesDatasetapi_pixclient_id: TStringField;
    ModalidadesDatasetapi_pixclient_secret: TStringField;
    ModalidadesDatasetapi_pixdeveloper_key: TStringField;
    ModalidadesDatasetapi_pixid: TIntegerField;
    ModalidadesDatasetapi_pixexcluido: TBooleanField;
    ModalidadesDatasetapi_pixinclusao: TDateTimeField;
    ModalidadesDatasetapi_pixalteracao: TDateTimeField;
    ModalidadesDatasetapi_pixexclusao: TDateTimeField;
    ModalidadesDatasetapi_pixchave_pix: TStringField;
    lbstatus: TLabel;
    edstatus: TDBEdit;
    ModalidadesDatasetpix_integrado: TBooleanField;
    ModalidadesDatasettipo_finalizar_venda: TIntegerField;
    ModalidadesDatasetstatus: TIntegerField;
    edtipo_finalizar_venda: TDBEdit;
    lbtipo_finalizar_venda: TLabel;
    lbpix_integrado: TLabel;
    cbxpix_integrado: TDBCheckBox;
    lbmodalidade_web: TLabel;
    cbxmodalidade_web: TDBCheckBox;
    ModalidadesDatasetmodalidade_web: TBooleanField;
    procedure btCancelClick(Sender: TObject);
    procedure XDataClientModalidadesGetLoad(Response: TXDataClientResponse);
    procedure ModalidadesDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure XDataWebClientBaixarArquivosError(Error: TXDataClientError);
    procedure XDataWebClientBaixarArquivosLoad(Response: TXDataClientResponse);
    procedure btnBaixarChavePrivadaClick(Sender: TObject);
    procedure btnBaixarCertificadoPemClick(Sender: TObject);
    procedure btnCopiarChavePixClick(Sender: TObject);
    procedure ModalidadesDatasettipo_cartaoGetText(Sender: TField;
      var Text: string; DisplayText: Boolean);
    procedure ModalidadesDatasetstatusGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
    procedure ModalidadesDatasettipo_finalizar_vendaGetText(Sender: TField;
      var Text: string; DisplayText: Boolean);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
    procedure BaixarArquivoPem(pChavePrivada : Boolean);
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewModalidadesEdit: TFViewModalidadesEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewModalidadesEdit }

class function TFViewModalidadesEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewModalidadesEdit.InsertEntity;
begin
  ModalidadesDataset.Close;
  ModalidadesDataset.SetJsonData('{}');
  ModalidadesDataset.Open;
  ModalidadesDataset.Insert;
end;

class function TFViewModalidadesEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewModalidadesEdit(AForm).FInserting := AInserting;
    TFViewModalidadesEdit(AForm).FId := AId;
    TFViewModalidadesEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewModalidadesEdit(AForm).InsertEntity
    else
      TFViewModalidadesEdit(AForm).LoadEntity;
  end;

begin
  Application.CreateForm(TFViewModalidadesEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewModalidadesEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    ModalidadesDataset.Connection.Model.DefaultSchema.FindEntityType(
      ModalidadesDataset.EntitySetName
    )
  );
  XDataClientModalidadesGet.Get(ModalidadesDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewModalidadesEdit.XDataClientModalidadesGetLoad(Response: TXDataClientResponse);
begin
  ModalidadesDataset.Close;
  ModalidadesDataset.SetJsonData(Response.Result);
  ModalidadesDataset.Open;
  
  ModalidadesDataset.Edit;

  if edchave_pix.Text = EmptyStr then
    btnCopiarChavePix.Enabled := False;

  if edapi_pix_id.Text = EmptyStr then
  begin
    TUtils.RemoverElementoPorId('line-api_pix-tab');
    TUtils.RemoverElementoPorId('line-api_pix');
  end;
end;

procedure TFViewModalidadesEdit.XDataWebClientBaixarArquivosError(
  Error: TXDataClientError);
begin
  TUtils.ChamarMensagemDialog(TTipoDialogo.ERROR, Error.ErrorMessage);
end;

procedure TFViewModalidadesEdit.XDataWebClientBaixarArquivosLoad(
  Response: TXDataClientResponse);
var
  lJSONObject: TJSObject;
begin
  lJSONObject := Response.ResultAsObject;
  THelperServer.BaixarAnexo(string(lJSONObject['arquivo_base64']), string(lJSONObject['arquivo_nome']));
end;

procedure TFViewModalidadesEdit.ModalidadesDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      Exit;
    end;
  end;
  FShowListProc;
end;

procedure TFViewModalidadesEdit.ModalidadesDatasetstatusGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  if not Sender.AsString.IsEmpty then
  begin
    if Sender.AsString = '1' then
      Text := 'Ativo'
    else
      Text := 'Inativo';
  end;
end;

procedure TFViewModalidadesEdit.ModalidadesDatasettipo_cartaoGetText(
  Sender: TField; var Text: string; DisplayText: Boolean);
begin
  if Sender.AsString = '1' then
    Text := 'CRÉDITO'
  else if Sender.AsString = '2' then
    Text := 'DÉBITO'
  else
    Text := EmptyStr;
end;

procedure TFViewModalidadesEdit.ModalidadesDatasettipo_finalizar_vendaGetText(
  Sender: TField; var Text: string; DisplayText: Boolean);
begin
  if not Sender.AsString.IsEmpty then
  begin
    case Sender.AsInteger of
      0 : Text := 'Transmitir o cupom';
      1: Text := 'Perguntar se deseja transmitir o cupom';
      2: Text := 'Não transmitir o cupom';
    end;
  end;
end;

procedure TFViewModalidadesEdit.BaixarArquivoPem(pChavePrivada: Boolean);
var
  lJson : TJSObject;
begin
  TUtils.ChamarDivLoading;

  lJson := TJSObject.New;

  if pChavePrivada then
    lJson['tipo'] := 'chave_privada'
  else
    lJson['tipo'] := 'certificado_pem';

  lJson['codigo'] := edapi_pix_id.Text;
  lJson['tabela'] := 'bancos_api_pix';

  XDataWebClientBaixarArquivos.RawInvoke('IService.BaixarArquivo', [lJson]);
end;

procedure TFViewModalidadesEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewModalidadesEdit.btnBaixarCertificadoPemClick(Sender: TObject);
begin
  BaixarArquivoPem(False);
end;

procedure TFViewModalidadesEdit.btnBaixarChavePrivadaClick(Sender: TObject);
begin
  BaixarArquivoPem(True);
end;

procedure TFViewModalidadesEdit.btnCopiarChavePixClick(Sender: TObject);
begin
  THelperServer.CopiarTextoNotificacao('Chave Pix copiada com sucesso!', 'Cópia de Chave Pix',
    edchave_pix.Text);
end;

procedure TFViewModalidadesEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbid := TLabel.Create('view.modalidades.form.lbid');
  lbnome := TLabel.Create('view.modalidades.form.lbnome');
  lbpermite_prazo := TLabel.Create('view.modalidades.form.lbpermite_prazo');
  lbmodalidade_avista := TLabel.Create('view.modalidades.form.lbmodalidade_avista');
  lbmodalidade_cheque_vinculado := TLabel.Create('view.modalidades.form.lbmodalidade_cheque_vinculado');
  lbmodalidade_prazo_fixo := TLabel.Create('view.modalidades.form.lbmodalidade_prazo_fixo');
  lbmodalidade_pagamento_digital := TLabel.Create('view.modalidades.form.lbmodalidade_pagamento_digital');
  lbmodalidade_pix := TLabel.Create('view.modalidades.form.lbmodalidade_pix');
  lbmodalidade_cartao := TLabel.Create('view.modalidades.form.lbmodalidade_cartao');
  lbtipo_cartao := TLabel.Create('view.modalidades.form.lbtipo_cartao');
  lbcomissao := TLabel.Create('view.modalidades.form.lbcomissao');
  lbprazo_dias := TLabel.Create('view.modalidades.form.lbprazo_dias');
  lbdia_fixo := TLabel.Create('view.modalidades.form.lbdia_fixo');
  lbparcela_minima := TLabel.Create('view.modalidades.form.lbparcela_minima');
  lbquantidade_parcelas := TLabel.Create('view.modalidades.form.lbquantidade_parcelas');
  lbtag_pagamento := TLabel.Create('view.modalidades.form.lbtag_pagamento');
  lbcodigo_interno := TLabel.Create('view.modalidades.form.lbcodigo_interno');
  lbexcluido := TLabel.Create('view.modalidades.form.lbexcluido');
  lbinclusao := TLabel.Create('view.modalidades.form.lbinclusao');
  lbalteracao := TLabel.Create('view.modalidades.form.lbalteracao');
  lbexclusao := TLabel.Create('view.modalidades.form.lbexclusao');
  lbapi_pix_id := TLabel.Create('view.modalidades.form.lbapi_pix_id');
  lbapi_pix_codigo_interno := TLabel.Create('view.modalidades.form.lbapi_pix_codigo_interno');
  lbclient_id := TLabel.Create('view.modalidades.form.lbclient_id');
  lbclient_secret := TLabel.Create('view.modalidades.form.lbclient_secret');
  lbdeveloper_key := TLabel.Create('view.modalidades.form.lbdeveloper_key');
  lbapi_pix_excluido := TLabel.Create('view.modalidades.form.lbapi_pix_excluido');
  lbapi_pix_inclusao := TLabel.Create('view.modalidades.form.lbapi_pix_inclusao');
  lbapi_pix_alteracao := TLabel.Create('view.modalidades.form.lbapi_pix_alteracao');
  lbapi_pix_exclusao := TLabel.Create('view.modalidades.form.lbapi_pix_exclusao');
  lbchave_pix := TLabel.Create('view.modalidades.form.lbchave_pix');
  lbstatus := TLabel.Create('view.modalidades.form.lbstatus');
  lbtipo_finalizar_venda := TLabel.Create('view.modalidades.form.lbtipo_finalizar_venda');
  lbpix_integrado := TLabel.Create('view.modalidades.form.lbpix_integrado');
  lbmodalidade_web := TLabel.Create('view.modalidades.form.lbmodalidade_web');
  btCancel := TButton.Create('view.modalidades.form.btBack');
  edid := TDBEdit.Create('view.modalidades.form.edid');
  ednome := TDBEdit.Create('view.modalidades.form.ednome');
  edtipo_cartao := TDBEdit.Create('view.modalidades.form.edtipo_cartao');
  edcomissao := TDBEdit.Create('view.modalidades.form.edcomissao');
  edprazo_dias := TDBEdit.Create('view.modalidades.form.edprazo_dias');
  eddia_fixo := TDBEdit.Create('view.modalidades.form.eddia_fixo');
  edparcela_minima := TDBEdit.Create('view.modalidades.form.edparcela_minima');
  edquantidade_parcelas := TDBEdit.Create('view.modalidades.form.edquantidade_parcelas');
  edtag_pagamento := TDBEdit.Create('view.modalidades.form.edtag_pagamento');
  edcodigo_interno := TDBEdit.Create('view.modalidades.form.edcodigo_interno');
  edinclusao := TDBEdit.Create('view.modalidades.form.edinclusao');
  edalteracao := TDBEdit.Create('view.modalidades.form.edalteracao');
  edexclusao := TDBEdit.Create('view.modalidades.form.edexclusao');
  pnlDadosModalidade := TPanel.Create(Self);
  cbxpermite_prazo := TDBCheckBox.Create('view.modalidades.form.cbxpermite_prazo');
  cbxmodalidade_avista := TDBCheckBox.Create('view.modalidades.form.cbxmodalidade_avista');
  cbxmodalidade_cheque_vinculado := TDBCheckBox.Create('view.modalidades.form.cbxmodalidade_cheque_vinculado');
  cbxmodalidade_prazo_fixo := TDBCheckBox.Create('view.modalidades.form.cbxmodalidade_prazo_fixo');
  cbxmodalidade_pagamento_digital := TDBCheckBox.Create('view.modalidades.form.cbxmodalidade_pagamento_digital');
  modalidade_pix := TDBCheckBox.Create('view.modalidades.form.cbxmodalidade_pix');
  cbxmodalidade_cartao := TDBCheckBox.Create('view.modalidades.form.cbxmodalidade_cartao');
  cbxexcluido := TDBCheckBox.Create('view.modalidades.form.cbxexcluido');
  pnlDadosSincronizacaoAutomatica := TPanel.Create(Self);
  edapi_pix_id := TDBEdit.Create('view.modalidades.form.edapi_pix_id');
  edapi_pix_codigo_interno := TDBEdit.Create('view.modalidades.form.edapi_pix_codigo_interno');
  edclient_id := TDBEdit.Create('view.modalidades.form.edclient_id');
  edclient_secret := TDBEdit.Create('view.modalidades.form.edclient_secret');
  eddeveloper_key := TDBEdit.Create('view.modalidades.form.eddeveloper_key');
  cbxapi_pix_excluido := TDBCheckBox.Create('view.modalidades.form.cbxapi_pix_excluido');
  edapi_pix_inclusao := TDBEdit.Create('view.modalidades.form.edapi_pix_inclusao');
  edapi_pix_alteracao := TDBEdit.Create('view.modalidades.form.edapi_pix_alteracao');
  edapi_pix_exclusao := TDBEdit.Create('view.modalidades.form.edapi_pix_exclusao');
  btnBaixarChavePrivada := TButton.Create('btnBaixarChavePrivada');
  btnBaixarCertificadoPem := TButton.Create('btnBaixarCertificadoPem');
  edchave_pix := TDBEdit.Create('view.modalidades.form.edchave_pix');
  btnCopiarChavePix := TButton.Create('btnCopiarChavePix');
  edstatus := TDBEdit.Create('view.modalidades.form.edstatus');
  edtipo_finalizar_venda := TDBEdit.Create('view.modalidades.form.edtipo_finalizar_venda');
  cbxpix_integrado := TDBCheckBox.Create('view.modalidades.form.cbxpix_integrado');
  cbxmodalidade_web := TDBCheckBox.Create('view.modalidades.form.cbxmodalidade_web');
  DataSource := TDataSource.Create(Self);
  ModalidadesDataset := TXDataWebDataSet.Create(Self);
  ModalidadesDatasetid := TIntegerField.Create(Self);
  ModalidadesDatasetaliado_id := TIntegerField.Create(Self);
  ModalidadesDatasetdata_base_id := TIntegerField.Create(Self);
  ModalidadesDatasetconta_id := TIntegerField.Create(Self);
  ModalidadesDatasetnome := TStringField.Create(Self);
  ModalidadesDatasetpermite_prazo := TBooleanField.Create(Self);
  ModalidadesDatasetmodalidade_avista := TBooleanField.Create(Self);
  ModalidadesDatasetmodalidade_cheque_vinculado := TBooleanField.Create(Self);
  ModalidadesDatasetmodalidade_prazo_fixo := TBooleanField.Create(Self);
  ModalidadesDatasetmodalidade_pagamento_digital := TBooleanField.Create(Self);
  ModalidadesDatasetmodalidade_pix := TBooleanField.Create(Self);
  ModalidadesDatasetmodalidade_cartao := TBooleanField.Create(Self);
  ModalidadesDatasettipo_cartao := TIntegerField.Create(Self);
  ModalidadesDatasetcomissao := TFloatField.Create(Self);
  ModalidadesDatasetprazo_dias := TIntegerField.Create(Self);
  ModalidadesDatasetdia_fixo := TIntegerField.Create(Self);
  ModalidadesDatasetparcela_minima := TFloatField.Create(Self);
  ModalidadesDatasetquantidade_parcelas := TIntegerField.Create(Self);
  ModalidadesDatasettag_pagamento := TStringField.Create(Self);
  ModalidadesDatasetcodigo_interno := TIntegerField.Create(Self);
  ModalidadesDatasetexcluido := TBooleanField.Create(Self);
  ModalidadesDatasetinclusao := TDateTimeField.Create(Self);
  ModalidadesDatasetalteracao := TDateTimeField.Create(Self);
  ModalidadesDatasetexclusao := TDateTimeField.Create(Self);
  ModalidadesDatasetapi_pixcodigo_interno := TIntegerField.Create(Self);
  ModalidadesDatasetapi_pixclient_id := TStringField.Create(Self);
  ModalidadesDatasetapi_pixclient_secret := TStringField.Create(Self);
  ModalidadesDatasetapi_pixdeveloper_key := TStringField.Create(Self);
  ModalidadesDatasetapi_pixid := TIntegerField.Create(Self);
  ModalidadesDatasetapi_pixexcluido := TBooleanField.Create(Self);
  ModalidadesDatasetapi_pixinclusao := TDateTimeField.Create(Self);
  ModalidadesDatasetapi_pixalteracao := TDateTimeField.Create(Self);
  ModalidadesDatasetapi_pixexclusao := TDateTimeField.Create(Self);
  ModalidadesDatasetapi_pixchave_pix := TStringField.Create(Self);
  ModalidadesDatasetpix_integrado := TBooleanField.Create(Self);
  ModalidadesDatasettipo_finalizar_venda := TIntegerField.Create(Self);
  ModalidadesDatasetstatus := TIntegerField.Create(Self);
  ModalidadesDatasetmodalidade_web := TBooleanField.Create(Self);
  XDataClientModalidadesGet := TXDataWebClient.Create(Self);
  XDataWebClientBaixarArquivos := TXDataWebClient.Create(Self);

  lbid.BeforeLoadDFMValues;
  lbnome.BeforeLoadDFMValues;
  lbpermite_prazo.BeforeLoadDFMValues;
  lbmodalidade_avista.BeforeLoadDFMValues;
  lbmodalidade_cheque_vinculado.BeforeLoadDFMValues;
  lbmodalidade_prazo_fixo.BeforeLoadDFMValues;
  lbmodalidade_pagamento_digital.BeforeLoadDFMValues;
  lbmodalidade_pix.BeforeLoadDFMValues;
  lbmodalidade_cartao.BeforeLoadDFMValues;
  lbtipo_cartao.BeforeLoadDFMValues;
  lbcomissao.BeforeLoadDFMValues;
  lbprazo_dias.BeforeLoadDFMValues;
  lbdia_fixo.BeforeLoadDFMValues;
  lbparcela_minima.BeforeLoadDFMValues;
  lbquantidade_parcelas.BeforeLoadDFMValues;
  lbtag_pagamento.BeforeLoadDFMValues;
  lbcodigo_interno.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  lbapi_pix_id.BeforeLoadDFMValues;
  lbapi_pix_codigo_interno.BeforeLoadDFMValues;
  lbclient_id.BeforeLoadDFMValues;
  lbclient_secret.BeforeLoadDFMValues;
  lbdeveloper_key.BeforeLoadDFMValues;
  lbapi_pix_excluido.BeforeLoadDFMValues;
  lbapi_pix_inclusao.BeforeLoadDFMValues;
  lbapi_pix_alteracao.BeforeLoadDFMValues;
  lbapi_pix_exclusao.BeforeLoadDFMValues;
  lbchave_pix.BeforeLoadDFMValues;
  lbstatus.BeforeLoadDFMValues;
  lbtipo_finalizar_venda.BeforeLoadDFMValues;
  lbpix_integrado.BeforeLoadDFMValues;
  lbmodalidade_web.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  ednome.BeforeLoadDFMValues;
  edtipo_cartao.BeforeLoadDFMValues;
  edcomissao.BeforeLoadDFMValues;
  edprazo_dias.BeforeLoadDFMValues;
  eddia_fixo.BeforeLoadDFMValues;
  edparcela_minima.BeforeLoadDFMValues;
  edquantidade_parcelas.BeforeLoadDFMValues;
  edtag_pagamento.BeforeLoadDFMValues;
  edcodigo_interno.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  pnlDadosModalidade.BeforeLoadDFMValues;
  cbxpermite_prazo.BeforeLoadDFMValues;
  cbxmodalidade_avista.BeforeLoadDFMValues;
  cbxmodalidade_cheque_vinculado.BeforeLoadDFMValues;
  cbxmodalidade_prazo_fixo.BeforeLoadDFMValues;
  cbxmodalidade_pagamento_digital.BeforeLoadDFMValues;
  modalidade_pix.BeforeLoadDFMValues;
  cbxmodalidade_cartao.BeforeLoadDFMValues;
  cbxexcluido.BeforeLoadDFMValues;
  pnlDadosSincronizacaoAutomatica.BeforeLoadDFMValues;
  edapi_pix_id.BeforeLoadDFMValues;
  edapi_pix_codigo_interno.BeforeLoadDFMValues;
  edclient_id.BeforeLoadDFMValues;
  edclient_secret.BeforeLoadDFMValues;
  eddeveloper_key.BeforeLoadDFMValues;
  cbxapi_pix_excluido.BeforeLoadDFMValues;
  edapi_pix_inclusao.BeforeLoadDFMValues;
  edapi_pix_alteracao.BeforeLoadDFMValues;
  edapi_pix_exclusao.BeforeLoadDFMValues;
  btnBaixarChavePrivada.BeforeLoadDFMValues;
  btnBaixarCertificadoPem.BeforeLoadDFMValues;
  edchave_pix.BeforeLoadDFMValues;
  btnCopiarChavePix.BeforeLoadDFMValues;
  edstatus.BeforeLoadDFMValues;
  edtipo_finalizar_venda.BeforeLoadDFMValues;
  cbxpix_integrado.BeforeLoadDFMValues;
  cbxmodalidade_web.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  ModalidadesDataset.BeforeLoadDFMValues;
  ModalidadesDatasetid.BeforeLoadDFMValues;
  ModalidadesDatasetaliado_id.BeforeLoadDFMValues;
  ModalidadesDatasetdata_base_id.BeforeLoadDFMValues;
  ModalidadesDatasetconta_id.BeforeLoadDFMValues;
  ModalidadesDatasetnome.BeforeLoadDFMValues;
  ModalidadesDatasetpermite_prazo.BeforeLoadDFMValues;
  ModalidadesDatasetmodalidade_avista.BeforeLoadDFMValues;
  ModalidadesDatasetmodalidade_cheque_vinculado.BeforeLoadDFMValues;
  ModalidadesDatasetmodalidade_prazo_fixo.BeforeLoadDFMValues;
  ModalidadesDatasetmodalidade_pagamento_digital.BeforeLoadDFMValues;
  ModalidadesDatasetmodalidade_pix.BeforeLoadDFMValues;
  ModalidadesDatasetmodalidade_cartao.BeforeLoadDFMValues;
  ModalidadesDatasettipo_cartao.BeforeLoadDFMValues;
  ModalidadesDatasetcomissao.BeforeLoadDFMValues;
  ModalidadesDatasetprazo_dias.BeforeLoadDFMValues;
  ModalidadesDatasetdia_fixo.BeforeLoadDFMValues;
  ModalidadesDatasetparcela_minima.BeforeLoadDFMValues;
  ModalidadesDatasetquantidade_parcelas.BeforeLoadDFMValues;
  ModalidadesDatasettag_pagamento.BeforeLoadDFMValues;
  ModalidadesDatasetcodigo_interno.BeforeLoadDFMValues;
  ModalidadesDatasetexcluido.BeforeLoadDFMValues;
  ModalidadesDatasetinclusao.BeforeLoadDFMValues;
  ModalidadesDatasetalteracao.BeforeLoadDFMValues;
  ModalidadesDatasetexclusao.BeforeLoadDFMValues;
  ModalidadesDatasetapi_pixcodigo_interno.BeforeLoadDFMValues;
  ModalidadesDatasetapi_pixclient_id.BeforeLoadDFMValues;
  ModalidadesDatasetapi_pixclient_secret.BeforeLoadDFMValues;
  ModalidadesDatasetapi_pixdeveloper_key.BeforeLoadDFMValues;
  ModalidadesDatasetapi_pixid.BeforeLoadDFMValues;
  ModalidadesDatasetapi_pixexcluido.BeforeLoadDFMValues;
  ModalidadesDatasetapi_pixinclusao.BeforeLoadDFMValues;
  ModalidadesDatasetapi_pixalteracao.BeforeLoadDFMValues;
  ModalidadesDatasetapi_pixexclusao.BeforeLoadDFMValues;
  ModalidadesDatasetapi_pixchave_pix.BeforeLoadDFMValues;
  ModalidadesDatasetpix_integrado.BeforeLoadDFMValues;
  ModalidadesDatasettipo_finalizar_venda.BeforeLoadDFMValues;
  ModalidadesDatasetstatus.BeforeLoadDFMValues;
  ModalidadesDatasetmodalidade_web.BeforeLoadDFMValues;
  XDataClientModalidadesGet.BeforeLoadDFMValues;
  XDataWebClientBaixarArquivos.BeforeLoadDFMValues;
  try
    Name := 'FViewModalidadesEdit';
    Width := 614;
    Height := 649;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 8;
    lbid.Top := 24;
    lbid.Width := 52;
    lbid.Height := 13;
    lbid.Caption := 'C'#243'd. Serv:';
    lbid.HeightPercent := 100.000000000000000000;
    lbid.WidthPercent := 100.000000000000000000;
    lbnome.SetParentComponent(Self);
    lbnome.Name := 'lbnome';
    lbnome.Left := 8;
    lbnome.Top := 52;
    lbnome.Width := 31;
    lbnome.Height := 13;
    lbnome.Caption := 'Nome:';
    lbnome.HeightPercent := 100.000000000000000000;
    lbnome.WidthPercent := 100.000000000000000000;
    lbpermite_prazo.SetParentComponent(Self);
    lbpermite_prazo.Name := 'lbpermite_prazo';
    lbpermite_prazo.Left := 8;
    lbpermite_prazo.Top := 79;
    lbpermite_prazo.Width := 71;
    lbpermite_prazo.Height := 13;
    lbpermite_prazo.Caption := 'Permite Prazo?';
    lbpermite_prazo.HeightPercent := 100.000000000000000000;
    lbpermite_prazo.WidthPercent := 100.000000000000000000;
    lbmodalidade_avista.SetParentComponent(Self);
    lbmodalidade_avista.Name := 'lbmodalidade_avista';
    lbmodalidade_avista.Left := 8;
    lbmodalidade_avista.Top := 106;
    lbmodalidade_avista.Width := 38;
    lbmodalidade_avista.Height := 13;
    lbmodalidade_avista.Caption := #192' Vista?';
    lbmodalidade_avista.HeightPercent := 100.000000000000000000;
    lbmodalidade_avista.WidthPercent := 100.000000000000000000;
    lbmodalidade_cheque_vinculado.SetParentComponent(Self);
    lbmodalidade_cheque_vinculado.Name := 'lbmodalidade_cheque_vinculado';
    lbmodalidade_cheque_vinculado.Left := 8;
    lbmodalidade_cheque_vinculado.Top := 133;
    lbmodalidade_cheque_vinculado.Width := 90;
    lbmodalidade_cheque_vinculado.Height := 13;
    lbmodalidade_cheque_vinculado.Caption := 'Cheque Vinculado?';
    lbmodalidade_cheque_vinculado.HeightPercent := 100.000000000000000000;
    lbmodalidade_cheque_vinculado.WidthPercent := 100.000000000000000000;
    lbmodalidade_prazo_fixo.SetParentComponent(Self);
    lbmodalidade_prazo_fixo.Name := 'lbmodalidade_prazo_fixo';
    lbmodalidade_prazo_fixo.Left := 8;
    lbmodalidade_prazo_fixo.Top := 160;
    lbmodalidade_prazo_fixo.Width := 55;
    lbmodalidade_prazo_fixo.Height := 13;
    lbmodalidade_prazo_fixo.Caption := 'Prazo Fixo?';
    lbmodalidade_prazo_fixo.HeightPercent := 100.000000000000000000;
    lbmodalidade_prazo_fixo.WidthPercent := 100.000000000000000000;
    lbmodalidade_pagamento_digital.SetParentComponent(Self);
    lbmodalidade_pagamento_digital.Name := 'lbmodalidade_pagamento_digital';
    lbmodalidade_pagamento_digital.Left := 8;
    lbmodalidade_pagamento_digital.Top := 187;
    lbmodalidade_pagamento_digital.Width := 91;
    lbmodalidade_pagamento_digital.Height := 13;
    lbmodalidade_pagamento_digital.Caption := 'Pagamento Digital?';
    lbmodalidade_pagamento_digital.HeightPercent := 100.000000000000000000;
    lbmodalidade_pagamento_digital.WidthPercent := 100.000000000000000000;
    lbmodalidade_pix.SetParentComponent(Self);
    lbmodalidade_pix.Name := 'lbmodalidade_pix';
    lbmodalidade_pix.Left := 8;
    lbmodalidade_pix.Top := 214;
    lbmodalidade_pix.Width := 19;
    lbmodalidade_pix.Height := 13;
    lbmodalidade_pix.Caption := 'Pix?';
    lbmodalidade_pix.HeightPercent := 100.000000000000000000;
    lbmodalidade_pix.WidthPercent := 100.000000000000000000;
    lbmodalidade_cartao.SetParentComponent(Self);
    lbmodalidade_cartao.Name := 'lbmodalidade_cartao';
    lbmodalidade_cartao.Left := 8;
    lbmodalidade_cartao.Top := 241;
    lbmodalidade_cartao.Width := 38;
    lbmodalidade_cartao.Height := 13;
    lbmodalidade_cartao.Caption := 'Cart'#227'o?';
    lbmodalidade_cartao.HeightPercent := 100.000000000000000000;
    lbmodalidade_cartao.WidthPercent := 100.000000000000000000;
    lbtipo_cartao.SetParentComponent(Self);
    lbtipo_cartao.Name := 'lbtipo_cartao';
    lbtipo_cartao.Left := 8;
    lbtipo_cartao.Top := 268;
    lbtipo_cartao.Width := 60;
    lbtipo_cartao.Height := 13;
    lbtipo_cartao.Caption := 'Tipo Cart'#227'o:';
    lbtipo_cartao.HeightPercent := 100.000000000000000000;
    lbtipo_cartao.WidthPercent := 100.000000000000000000;
    lbcomissao.SetParentComponent(Self);
    lbcomissao.Name := 'lbcomissao';
    lbcomissao.Left := 8;
    lbcomissao.Top := 295;
    lbcomissao.Width := 49;
    lbcomissao.Height := 13;
    lbcomissao.Caption := 'Comiss'#227'o:';
    lbcomissao.HeightPercent := 100.000000000000000000;
    lbcomissao.WidthPercent := 100.000000000000000000;
    lbprazo_dias.SetParentComponent(Self);
    lbprazo_dias.Name := 'lbprazo_dias';
    lbprazo_dias.Left := 256;
    lbprazo_dias.Top := 24;
    lbprazo_dias.Width := 54;
    lbprazo_dias.Height := 13;
    lbprazo_dias.Caption := 'Prazo Dias:';
    lbprazo_dias.HeightPercent := 100.000000000000000000;
    lbprazo_dias.WidthPercent := 100.000000000000000000;
    lbdia_fixo.SetParentComponent(Self);
    lbdia_fixo.Name := 'lbdia_fixo';
    lbdia_fixo.Left := 256;
    lbdia_fixo.Top := 51;
    lbdia_fixo.Width := 42;
    lbdia_fixo.Height := 13;
    lbdia_fixo.Caption := 'Dia Fixo:';
    lbdia_fixo.HeightPercent := 100.000000000000000000;
    lbdia_fixo.WidthPercent := 100.000000000000000000;
    lbparcela_minima.SetParentComponent(Self);
    lbparcela_minima.Name := 'lbparcela_minima';
    lbparcela_minima.Left := 256;
    lbparcela_minima.Top := 78;
    lbparcela_minima.Width := 74;
    lbparcela_minima.Height := 13;
    lbparcela_minima.Caption := 'Parcela M'#237'nima:';
    lbparcela_minima.HeightPercent := 100.000000000000000000;
    lbparcela_minima.WidthPercent := 100.000000000000000000;
    lbquantidade_parcelas.SetParentComponent(Self);
    lbquantidade_parcelas.Name := 'lbquantidade_parcelas';
    lbquantidade_parcelas.Left := 256;
    lbquantidade_parcelas.Top := 105;
    lbquantidade_parcelas.Width := 75;
    lbquantidade_parcelas.Height := 13;
    lbquantidade_parcelas.Caption := 'Qtde. Parcelas:';
    lbquantidade_parcelas.HeightPercent := 100.000000000000000000;
    lbquantidade_parcelas.WidthPercent := 100.000000000000000000;
    lbtag_pagamento.SetParentComponent(Self);
    lbtag_pagamento.Name := 'lbtag_pagamento';
    lbtag_pagamento.Left := 256;
    lbtag_pagamento.Top := 132;
    lbtag_pagamento.Width := 79;
    lbtag_pagamento.Height := 13;
    lbtag_pagamento.Caption := 'Tag Pagamento:';
    lbtag_pagamento.HeightPercent := 100.000000000000000000;
    lbtag_pagamento.WidthPercent := 100.000000000000000000;
    lbcodigo_interno.SetParentComponent(Self);
    lbcodigo_interno.Name := 'lbcodigo_interno';
    lbcodigo_interno.Left := 256;
    lbcodigo_interno.Top := 159;
    lbcodigo_interno.Width := 47;
    lbcodigo_interno.Height := 13;
    lbcodigo_interno.Caption := 'C'#243'd. Ret:';
    lbcodigo_interno.HeightPercent := 100.000000000000000000;
    lbcodigo_interno.WidthPercent := 100.000000000000000000;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 256;
    lbexcluido.Top := 186;
    lbexcluido.Width := 44;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'Exclu'#237'do?';
    lbexcluido.HeightPercent := 100.000000000000000000;
    lbexcluido.WidthPercent := 100.000000000000000000;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 256;
    lbinclusao.Top := 213;
    lbinclusao.Width := 44;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'Inclus'#227'o:';
    lbinclusao.HeightPercent := 100.000000000000000000;
    lbinclusao.WidthPercent := 100.000000000000000000;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 256;
    lbalteracao.Top := 240;
    lbalteracao.Width := 50;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'Altera'#231#227'o:';
    lbalteracao.HeightPercent := 100.000000000000000000;
    lbalteracao.WidthPercent := 100.000000000000000000;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 256;
    lbexclusao.Top := 267;
    lbexclusao.Width := 46;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'Exclus'#227'o:';
    lbexclusao.HeightPercent := 100.000000000000000000;
    lbexclusao.WidthPercent := 100.000000000000000000;
    lbapi_pix_id.SetParentComponent(Self);
    lbapi_pix_id.Name := 'lbapi_pix_id';
    lbapi_pix_id.Left := 8;
    lbapi_pix_id.Top := 440;
    lbapi_pix_id.Width := 52;
    lbapi_pix_id.Height := 13;
    lbapi_pix_id.Caption := 'C'#243'd. Serv:';
    lbapi_pix_id.HeightPercent := 100.000000000000000000;
    lbapi_pix_id.WidthPercent := 100.000000000000000000;
    lbapi_pix_codigo_interno.SetParentComponent(Self);
    lbapi_pix_codigo_interno.Name := 'lbapi_pix_codigo_interno';
    lbapi_pix_codigo_interno.Left := 8;
    lbapi_pix_codigo_interno.Top := 467;
    lbapi_pix_codigo_interno.Width := 47;
    lbapi_pix_codigo_interno.Height := 13;
    lbapi_pix_codigo_interno.Caption := 'C'#243'd. Ret:';
    lbapi_pix_codigo_interno.HeightPercent := 100.000000000000000000;
    lbapi_pix_codigo_interno.WidthPercent := 100.000000000000000000;
    lbclient_id.SetParentComponent(Self);
    lbclient_id.Name := 'lbclient_id';
    lbclient_id.Left := 8;
    lbclient_id.Top := 494;
    lbclient_id.Width := 44;
    lbclient_id.Height := 13;
    lbclient_id.Caption := 'Client Id:';
    lbclient_id.HeightPercent := 100.000000000000000000;
    lbclient_id.WidthPercent := 100.000000000000000000;
    lbclient_secret.SetParentComponent(Self);
    lbclient_secret.Name := 'lbclient_secret';
    lbclient_secret.Left := 8;
    lbclient_secret.Top := 521;
    lbclient_secret.Width := 65;
    lbclient_secret.Height := 13;
    lbclient_secret.Caption := 'Client Secret:';
    lbclient_secret.HeightPercent := 100.000000000000000000;
    lbclient_secret.WidthPercent := 100.000000000000000000;
    lbdeveloper_key.SetParentComponent(Self);
    lbdeveloper_key.Name := 'lbdeveloper_key';
    lbdeveloper_key.Left := 8;
    lbdeveloper_key.Top := 548;
    lbdeveloper_key.Width := 74;
    lbdeveloper_key.Height := 13;
    lbdeveloper_key.Caption := 'Developer Key:';
    lbdeveloper_key.HeightPercent := 100.000000000000000000;
    lbdeveloper_key.WidthPercent := 100.000000000000000000;
    lbapi_pix_excluido.SetParentComponent(Self);
    lbapi_pix_excluido.Name := 'lbapi_pix_excluido';
    lbapi_pix_excluido.Left := 256;
    lbapi_pix_excluido.Top := 440;
    lbapi_pix_excluido.Width := 44;
    lbapi_pix_excluido.Height := 13;
    lbapi_pix_excluido.Caption := 'Exclu'#237'do?';
    lbapi_pix_excluido.HeightPercent := 100.000000000000000000;
    lbapi_pix_excluido.WidthPercent := 100.000000000000000000;
    lbapi_pix_inclusao.SetParentComponent(Self);
    lbapi_pix_inclusao.Name := 'lbapi_pix_inclusao';
    lbapi_pix_inclusao.Left := 256;
    lbapi_pix_inclusao.Top := 467;
    lbapi_pix_inclusao.Width := 44;
    lbapi_pix_inclusao.Height := 13;
    lbapi_pix_inclusao.Caption := 'Inclus'#227'o:';
    lbapi_pix_inclusao.HeightPercent := 100.000000000000000000;
    lbapi_pix_inclusao.WidthPercent := 100.000000000000000000;
    lbapi_pix_alteracao.SetParentComponent(Self);
    lbapi_pix_alteracao.Name := 'lbapi_pix_alteracao';
    lbapi_pix_alteracao.Left := 256;
    lbapi_pix_alteracao.Top := 494;
    lbapi_pix_alteracao.Width := 50;
    lbapi_pix_alteracao.Height := 13;
    lbapi_pix_alteracao.Caption := 'Altera'#231#227'o:';
    lbapi_pix_alteracao.HeightPercent := 100.000000000000000000;
    lbapi_pix_alteracao.WidthPercent := 100.000000000000000000;
    lbapi_pix_exclusao.SetParentComponent(Self);
    lbapi_pix_exclusao.Name := 'lbapi_pix_exclusao';
    lbapi_pix_exclusao.Left := 256;
    lbapi_pix_exclusao.Top := 521;
    lbapi_pix_exclusao.Width := 46;
    lbapi_pix_exclusao.Height := 13;
    lbapi_pix_exclusao.Caption := 'Exclus'#227'o:';
    lbapi_pix_exclusao.HeightPercent := 100.000000000000000000;
    lbapi_pix_exclusao.WidthPercent := 100.000000000000000000;
    lbchave_pix.SetParentComponent(Self);
    lbchave_pix.Name := 'lbchave_pix';
    lbchave_pix.Left := 257;
    lbchave_pix.Top := 548;
    lbchave_pix.Width := 52;
    lbchave_pix.Height := 13;
    lbchave_pix.Caption := 'Chave Pix:';
    lbchave_pix.HeightPercent := 100.000000000000000000;
    lbchave_pix.WidthPercent := 100.000000000000000000;
    lbstatus.SetParentComponent(Self);
    lbstatus.Name := 'lbstatus';
    lbstatus.Left := 8;
    lbstatus.Top := 322;
    lbstatus.Width := 35;
    lbstatus.Height := 13;
    lbstatus.Caption := 'Status:';
    lbstatus.HeightPercent := 100.000000000000000000;
    lbstatus.WidthPercent := 100.000000000000000000;
    lbtipo_finalizar_venda.SetParentComponent(Self);
    lbtipo_finalizar_venda.Name := 'lbtipo_finalizar_venda';
    lbtipo_finalizar_venda.Left := 256;
    lbtipo_finalizar_venda.Top := 295;
    lbtipo_finalizar_venda.Width := 99;
    lbtipo_finalizar_venda.Height := 13;
    lbtipo_finalizar_venda.Caption := 'Tipo Finalizar Venda:';
    lbtipo_finalizar_venda.HeightPercent := 100.000000000000000000;
    lbtipo_finalizar_venda.WidthPercent := 100.000000000000000000;
    lbpix_integrado.SetParentComponent(Self);
    lbpix_integrado.Name := 'lbpix_integrado';
    lbpix_integrado.Left := 256;
    lbpix_integrado.Top := 322;
    lbpix_integrado.Width := 70;
    lbpix_integrado.Height := 13;
    lbpix_integrado.Caption := 'Pix Integrado?';
    lbpix_integrado.HeightPercent := 100.000000000000000000;
    lbpix_integrado.WidthPercent := 100.000000000000000000;
    lbmodalidade_web.SetParentComponent(Self);
    lbmodalidade_web.Name := 'lbmodalidade_web';
    lbmodalidade_web.Left := 256;
    lbmodalidade_web.Top := 349;
    lbmodalidade_web.Width := 27;
    lbmodalidade_web.Height := 13;
    lbmodalidade_web.Caption := 'Web?';
    lbmodalidade_web.HeightPercent := 100.000000000000000000;
    lbmodalidade_web.WidthPercent := 100.000000000000000000;
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 352;
    btCancel.Top := 383;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Voltar';
    btCancel.HeightPercent := 100.000000000000000000;
    btCancel.TabOrder := 1;
    btCancel.WidthPercent := 100.000000000000000000;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 117;
    edid.Top := 21;
    edid.Width := 120;
    edid.Height := 21;
    edid.Enabled := False;
    edid.HeightPercent := 100.000000000000000000;
    edid.TabOrder := 6;
    edid.Text := 'edid';
    edid.WidthPercent := 100.000000000000000000;
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    ednome.SetParentComponent(Self);
    ednome.Name := 'ednome';
    ednome.Left := 117;
    ednome.Top := 49;
    ednome.Width := 120;
    ednome.Height := 21;
    ednome.Enabled := False;
    ednome.HeightPercent := 100.000000000000000000;
    ednome.TabOrder := 10;
    ednome.Text := 'ednome';
    ednome.WidthPercent := 100.000000000000000000;
    ednome.DataField := 'nome';
    ednome.DataSource := DataSource;
    edtipo_cartao.SetParentComponent(Self);
    edtipo_cartao.Name := 'edtipo_cartao';
    edtipo_cartao.Left := 117;
    edtipo_cartao.Top := 265;
    edtipo_cartao.Width := 120;
    edtipo_cartao.Height := 21;
    edtipo_cartao.Enabled := False;
    edtipo_cartao.HeightPercent := 100.000000000000000000;
    edtipo_cartao.TabOrder := 18;
    edtipo_cartao.Text := 'edtipo_cartao';
    edtipo_cartao.WidthPercent := 100.000000000000000000;
    edtipo_cartao.DataField := 'tipo_cartao';
    edtipo_cartao.DataSource := DataSource;
    edcomissao.SetParentComponent(Self);
    edcomissao.Name := 'edcomissao';
    edcomissao.Left := 117;
    edcomissao.Top := 292;
    edcomissao.Width := 120;
    edcomissao.Height := 21;
    edcomissao.Enabled := False;
    edcomissao.HeightPercent := 100.000000000000000000;
    edcomissao.TabOrder := 19;
    edcomissao.Text := 'edcomissao';
    edcomissao.WidthPercent := 100.000000000000000000;
    edcomissao.DataField := 'comissao';
    edcomissao.DataSource := DataSource;
    edprazo_dias.SetParentComponent(Self);
    edprazo_dias.Name := 'edprazo_dias';
    edprazo_dias.Left := 373;
    edprazo_dias.Top := 21;
    edprazo_dias.Width := 120;
    edprazo_dias.Height := 21;
    edprazo_dias.Enabled := False;
    edprazo_dias.HeightPercent := 100.000000000000000000;
    edprazo_dias.TabOrder := 20;
    edprazo_dias.Text := 'edprazo_dias';
    edprazo_dias.WidthPercent := 100.000000000000000000;
    edprazo_dias.DataField := 'prazo_dias';
    edprazo_dias.DataSource := DataSource;
    eddia_fixo.SetParentComponent(Self);
    eddia_fixo.Name := 'eddia_fixo';
    eddia_fixo.Left := 373;
    eddia_fixo.Top := 48;
    eddia_fixo.Width := 120;
    eddia_fixo.Height := 21;
    eddia_fixo.Enabled := False;
    eddia_fixo.HeightPercent := 100.000000000000000000;
    eddia_fixo.TabOrder := 21;
    eddia_fixo.Text := 'eddia_fixo';
    eddia_fixo.WidthPercent := 100.000000000000000000;
    eddia_fixo.DataField := 'dia_fixo';
    eddia_fixo.DataSource := DataSource;
    edparcela_minima.SetParentComponent(Self);
    edparcela_minima.Name := 'edparcela_minima';
    edparcela_minima.Left := 373;
    edparcela_minima.Top := 75;
    edparcela_minima.Width := 120;
    edparcela_minima.Height := 21;
    edparcela_minima.Enabled := False;
    edparcela_minima.HeightPercent := 100.000000000000000000;
    edparcela_minima.TabOrder := 22;
    edparcela_minima.Text := 'edparcela_minima';
    edparcela_minima.WidthPercent := 100.000000000000000000;
    edparcela_minima.DataField := 'parcela_minima';
    edparcela_minima.DataSource := DataSource;
    edquantidade_parcelas.SetParentComponent(Self);
    edquantidade_parcelas.Name := 'edquantidade_parcelas';
    edquantidade_parcelas.Left := 373;
    edquantidade_parcelas.Top := 102;
    edquantidade_parcelas.Width := 120;
    edquantidade_parcelas.Height := 21;
    edquantidade_parcelas.Enabled := False;
    edquantidade_parcelas.HeightPercent := 100.000000000000000000;
    edquantidade_parcelas.TabOrder := 23;
    edquantidade_parcelas.Text := 'edquantidade_parcelas';
    edquantidade_parcelas.WidthPercent := 100.000000000000000000;
    edquantidade_parcelas.DataField := 'quantidade_parcelas';
    edquantidade_parcelas.DataSource := DataSource;
    edtag_pagamento.SetParentComponent(Self);
    edtag_pagamento.Name := 'edtag_pagamento';
    edtag_pagamento.Left := 373;
    edtag_pagamento.Top := 129;
    edtag_pagamento.Width := 120;
    edtag_pagamento.Height := 21;
    edtag_pagamento.Enabled := False;
    edtag_pagamento.HeightPercent := 100.000000000000000000;
    edtag_pagamento.TabOrder := 24;
    edtag_pagamento.Text := 'edtag_pagamento';
    edtag_pagamento.WidthPercent := 100.000000000000000000;
    edtag_pagamento.DataField := 'tag_pagamento';
    edtag_pagamento.DataSource := DataSource;
    edcodigo_interno.SetParentComponent(Self);
    edcodigo_interno.Name := 'edcodigo_interno';
    edcodigo_interno.Left := 373;
    edcodigo_interno.Top := 156;
    edcodigo_interno.Width := 120;
    edcodigo_interno.Height := 21;
    edcodigo_interno.Enabled := False;
    edcodigo_interno.HeightPercent := 100.000000000000000000;
    edcodigo_interno.TabOrder := 25;
    edcodigo_interno.Text := 'edcodigo_interno';
    edcodigo_interno.WidthPercent := 100.000000000000000000;
    edcodigo_interno.DataField := 'codigo_interno';
    edcodigo_interno.DataSource := DataSource;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 373;
    edinclusao.Top := 210;
    edinclusao.Width := 120;
    edinclusao.Height := 21;
    edinclusao.Enabled := False;
    edinclusao.HeightPercent := 100.000000000000000000;
    edinclusao.TabOrder := 27;
    edinclusao.Text := 'edinclusao';
    edinclusao.WidthPercent := 100.000000000000000000;
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 373;
    edalteracao.Top := 237;
    edalteracao.Width := 120;
    edalteracao.Height := 21;
    edalteracao.Enabled := False;
    edalteracao.HeightPercent := 100.000000000000000000;
    edalteracao.TabOrder := 28;
    edalteracao.Text := 'edalteracao';
    edalteracao.WidthPercent := 100.000000000000000000;
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 373;
    edexclusao.Top := 264;
    edexclusao.Width := 120;
    edexclusao.Height := 21;
    edexclusao.Enabled := False;
    edexclusao.HeightPercent := 100.000000000000000000;
    edexclusao.TabOrder := 29;
    edexclusao.Text := 'edexclusao';
    edexclusao.WidthPercent := 100.000000000000000000;
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    pnlDadosModalidade.SetParentComponent(Self);
    pnlDadosModalidade.Name := 'pnlDadosModalidade';
    pnlDadosModalidade.Left := 8;
    pnlDadosModalidade.Top := 0;
    pnlDadosModalidade.Width := 485;
    pnlDadosModalidade.Height := 17;
    pnlDadosModalidade.Caption := 'Espa'#231'o Dados Modalidade';
    pnlDadosModalidade.ChildOrder := 23;
    pnlDadosModalidade.Color := clInfoText;
    pnlDadosModalidade.Font.Charset := DEFAULT_CHARSET;
    pnlDadosModalidade.Font.Color := clWhite;
    pnlDadosModalidade.Font.Height := -11;
    pnlDadosModalidade.Font.Name := 'Tahoma';
    pnlDadosModalidade.Font.Style := [fsBold];
    pnlDadosModalidade.ParentFont := False;
    pnlDadosModalidade.TabOrder := 14;
    pnlDadosModalidade.Visible := False;
    cbxpermite_prazo.SetParentComponent(Self);
    cbxpermite_prazo.Name := 'cbxpermite_prazo';
    cbxpermite_prazo.Left := 117;
    cbxpermite_prazo.Top := 76;
    cbxpermite_prazo.Width := 120;
    cbxpermite_prazo.Height := 22;
    cbxpermite_prazo.Caption := 'cbxpermite_prazo';
    cbxpermite_prazo.ChildOrder := 33;
    cbxpermite_prazo.Enabled := False;
    cbxpermite_prazo.HeightPercent := 100.000000000000000000;
    cbxpermite_prazo.WidthPercent := 100.000000000000000000;
    cbxpermite_prazo.DataField := 'permite_prazo';
    cbxpermite_prazo.DataSource := DataSource;
    cbxmodalidade_avista.SetParentComponent(Self);
    cbxmodalidade_avista.Name := 'cbxmodalidade_avista';
    cbxmodalidade_avista.Left := 117;
    cbxmodalidade_avista.Top := 103;
    cbxmodalidade_avista.Width := 120;
    cbxmodalidade_avista.Height := 22;
    cbxmodalidade_avista.Caption := 'cbxmodalidade_avista';
    cbxmodalidade_avista.ChildOrder := 33;
    cbxmodalidade_avista.Enabled := False;
    cbxmodalidade_avista.HeightPercent := 100.000000000000000000;
    cbxmodalidade_avista.WidthPercent := 100.000000000000000000;
    cbxmodalidade_avista.DataField := 'modalidade_avista';
    cbxmodalidade_avista.DataSource := DataSource;
    cbxmodalidade_cheque_vinculado.SetParentComponent(Self);
    cbxmodalidade_cheque_vinculado.Name := 'cbxmodalidade_cheque_vinculado';
    cbxmodalidade_cheque_vinculado.Left := 117;
    cbxmodalidade_cheque_vinculado.Top := 130;
    cbxmodalidade_cheque_vinculado.Width := 120;
    cbxmodalidade_cheque_vinculado.Height := 22;
    cbxmodalidade_cheque_vinculado.Caption := 'cbxmodalidade_cheque_vinculado';
    cbxmodalidade_cheque_vinculado.ChildOrder := 33;
    cbxmodalidade_cheque_vinculado.Enabled := False;
    cbxmodalidade_cheque_vinculado.HeightPercent := 100.000000000000000000;
    cbxmodalidade_cheque_vinculado.WidthPercent := 100.000000000000000000;
    cbxmodalidade_cheque_vinculado.DataField := 'modalidade_cheque_vinculado';
    cbxmodalidade_cheque_vinculado.DataSource := DataSource;
    cbxmodalidade_prazo_fixo.SetParentComponent(Self);
    cbxmodalidade_prazo_fixo.Name := 'cbxmodalidade_prazo_fixo';
    cbxmodalidade_prazo_fixo.Left := 117;
    cbxmodalidade_prazo_fixo.Top := 157;
    cbxmodalidade_prazo_fixo.Width := 120;
    cbxmodalidade_prazo_fixo.Height := 22;
    cbxmodalidade_prazo_fixo.Caption := 'cbxmodalidade_prazo_fixo';
    cbxmodalidade_prazo_fixo.ChildOrder := 33;
    cbxmodalidade_prazo_fixo.Enabled := False;
    cbxmodalidade_prazo_fixo.HeightPercent := 100.000000000000000000;
    cbxmodalidade_prazo_fixo.WidthPercent := 100.000000000000000000;
    cbxmodalidade_prazo_fixo.DataField := 'modalidade_prazo_fixo';
    cbxmodalidade_prazo_fixo.DataSource := DataSource;
    cbxmodalidade_pagamento_digital.SetParentComponent(Self);
    cbxmodalidade_pagamento_digital.Name := 'cbxmodalidade_pagamento_digital';
    cbxmodalidade_pagamento_digital.Left := 117;
    cbxmodalidade_pagamento_digital.Top := 184;
    cbxmodalidade_pagamento_digital.Width := 120;
    cbxmodalidade_pagamento_digital.Height := 22;
    cbxmodalidade_pagamento_digital.Caption := 'cbxmodalidade_pagamento_digital';
    cbxmodalidade_pagamento_digital.ChildOrder := 33;
    cbxmodalidade_pagamento_digital.Enabled := False;
    cbxmodalidade_pagamento_digital.HeightPercent := 100.000000000000000000;
    cbxmodalidade_pagamento_digital.WidthPercent := 100.000000000000000000;
    cbxmodalidade_pagamento_digital.DataField := 'modalidade_pagamento_digital';
    cbxmodalidade_pagamento_digital.DataSource := DataSource;
    modalidade_pix.SetParentComponent(Self);
    modalidade_pix.Name := 'modalidade_pix';
    modalidade_pix.Left := 117;
    modalidade_pix.Top := 211;
    modalidade_pix.Width := 120;
    modalidade_pix.Height := 22;
    modalidade_pix.Caption := 'cbxmodalidade_pix';
    modalidade_pix.ChildOrder := 33;
    modalidade_pix.Enabled := False;
    modalidade_pix.HeightPercent := 100.000000000000000000;
    modalidade_pix.WidthPercent := 100.000000000000000000;
    modalidade_pix.DataField := 'modalidade_pix';
    modalidade_pix.DataSource := DataSource;
    cbxmodalidade_cartao.SetParentComponent(Self);
    cbxmodalidade_cartao.Name := 'cbxmodalidade_cartao';
    cbxmodalidade_cartao.Left := 117;
    cbxmodalidade_cartao.Top := 238;
    cbxmodalidade_cartao.Width := 120;
    cbxmodalidade_cartao.Height := 22;
    cbxmodalidade_cartao.Caption := 'cbxmodalidade_cartao';
    cbxmodalidade_cartao.ChildOrder := 33;
    cbxmodalidade_cartao.Enabled := False;
    cbxmodalidade_cartao.HeightPercent := 100.000000000000000000;
    cbxmodalidade_cartao.WidthPercent := 100.000000000000000000;
    cbxmodalidade_cartao.DataField := 'modalidade_cartao';
    cbxmodalidade_cartao.DataSource := DataSource;
    cbxexcluido.SetParentComponent(Self);
    cbxexcluido.Name := 'cbxexcluido';
    cbxexcluido.Left := 373;
    cbxexcluido.Top := 183;
    cbxexcluido.Width := 120;
    cbxexcluido.Height := 22;
    cbxexcluido.Caption := 'cbxexcluido';
    cbxexcluido.ChildOrder := 33;
    cbxexcluido.Enabled := False;
    cbxexcluido.HeightPercent := 100.000000000000000000;
    cbxexcluido.WidthPercent := 100.000000000000000000;
    cbxexcluido.DataField := 'excluido';
    cbxexcluido.DataSource := DataSource;
    pnlDadosSincronizacaoAutomatica.SetParentComponent(Self);
    pnlDadosSincronizacaoAutomatica.Name := 'pnlDadosSincronizacaoAutomatica';
    pnlDadosSincronizacaoAutomatica.Left := 8;
    pnlDadosSincronizacaoAutomatica.Top := 414;
    pnlDadosSincronizacaoAutomatica.Width := 485;
    pnlDadosSincronizacaoAutomatica.Height := 17;
    pnlDadosSincronizacaoAutomatica.Caption := 'Espa'#231'o Dados Sinc. Aut.';
    pnlDadosSincronizacaoAutomatica.ChildOrder := 23;
    pnlDadosSincronizacaoAutomatica.Color := clInfoText;
    pnlDadosSincronizacaoAutomatica.Font.Charset := DEFAULT_CHARSET;
    pnlDadosSincronizacaoAutomatica.Font.Color := clWhite;
    pnlDadosSincronizacaoAutomatica.Font.Height := -11;
    pnlDadosSincronizacaoAutomatica.Font.Name := 'Tahoma';
    pnlDadosSincronizacaoAutomatica.Font.Style := [fsBold];
    pnlDadosSincronizacaoAutomatica.ParentFont := False;
    pnlDadosSincronizacaoAutomatica.TabOrder := 23;
    pnlDadosSincronizacaoAutomatica.Visible := False;
    edapi_pix_id.SetParentComponent(Self);
    edapi_pix_id.Name := 'edapi_pix_id';
    edapi_pix_id.Left := 93;
    edapi_pix_id.Top := 437;
    edapi_pix_id.Width := 120;
    edapi_pix_id.Height := 21;
    edapi_pix_id.ChildOrder := 31;
    edapi_pix_id.Enabled := False;
    edapi_pix_id.HeightPercent := 100.000000000000000000;
    edapi_pix_id.TabOrder := 6;
    edapi_pix_id.Text := 'edapi_pix_id';
    edapi_pix_id.WidthPercent := 100.000000000000000000;
    edapi_pix_id.DataField := 'api_pix.id';
    edapi_pix_id.DataSource := DataSource;
    edapi_pix_codigo_interno.SetParentComponent(Self);
    edapi_pix_codigo_interno.Name := 'edapi_pix_codigo_interno';
    edapi_pix_codigo_interno.Left := 93;
    edapi_pix_codigo_interno.Top := 464;
    edapi_pix_codigo_interno.Width := 120;
    edapi_pix_codigo_interno.Height := 21;
    edapi_pix_codigo_interno.ChildOrder := 33;
    edapi_pix_codigo_interno.Enabled := False;
    edapi_pix_codigo_interno.HeightPercent := 100.000000000000000000;
    edapi_pix_codigo_interno.TabOrder := 12;
    edapi_pix_codigo_interno.Text := 'edapi_pix_codigo_interno';
    edapi_pix_codigo_interno.WidthPercent := 100.000000000000000000;
    edapi_pix_codigo_interno.DataField := 'api_pix.codigo_interno';
    edapi_pix_codigo_interno.DataSource := DataSource;
    edclient_id.SetParentComponent(Self);
    edclient_id.Name := 'edclient_id';
    edclient_id.Left := 93;
    edclient_id.Top := 491;
    edclient_id.Width := 120;
    edclient_id.Height := 21;
    edclient_id.ChildOrder := 31;
    edclient_id.Enabled := False;
    edclient_id.HeightPercent := 100.000000000000000000;
    edclient_id.TabOrder := 6;
    edclient_id.Text := 'edclient_id';
    edclient_id.WidthPercent := 100.000000000000000000;
    edclient_id.DataField := 'api_pix.client_id';
    edclient_id.DataSource := DataSource;
    edclient_secret.SetParentComponent(Self);
    edclient_secret.Name := 'edclient_secret';
    edclient_secret.Left := 93;
    edclient_secret.Top := 518;
    edclient_secret.Width := 120;
    edclient_secret.Height := 21;
    edclient_secret.ChildOrder := 31;
    edclient_secret.Enabled := False;
    edclient_secret.HeightPercent := 100.000000000000000000;
    edclient_secret.TabOrder := 6;
    edclient_secret.Text := 'edclient_secret';
    edclient_secret.WidthPercent := 100.000000000000000000;
    edclient_secret.DataField := 'api_pix.client_secret';
    edclient_secret.DataSource := DataSource;
    eddeveloper_key.SetParentComponent(Self);
    eddeveloper_key.Name := 'eddeveloper_key';
    eddeveloper_key.Left := 93;
    eddeveloper_key.Top := 545;
    eddeveloper_key.Width := 120;
    eddeveloper_key.Height := 21;
    eddeveloper_key.ChildOrder := 31;
    eddeveloper_key.Enabled := False;
    eddeveloper_key.HeightPercent := 100.000000000000000000;
    eddeveloper_key.TabOrder := 6;
    eddeveloper_key.Text := 'eddeveloper_key';
    eddeveloper_key.WidthPercent := 100.000000000000000000;
    eddeveloper_key.DataField := 'api_pix.developer_key';
    eddeveloper_key.DataSource := DataSource;
    cbxapi_pix_excluido.SetParentComponent(Self);
    cbxapi_pix_excluido.Name := 'cbxapi_pix_excluido';
    cbxapi_pix_excluido.Left := 373;
    cbxapi_pix_excluido.Top := 437;
    cbxapi_pix_excluido.Width := 120;
    cbxapi_pix_excluido.Height := 22;
    cbxapi_pix_excluido.Caption := 'cbxexcluido';
    cbxapi_pix_excluido.ChildOrder := 33;
    cbxapi_pix_excluido.Enabled := False;
    cbxapi_pix_excluido.HeightPercent := 100.000000000000000000;
    cbxapi_pix_excluido.WidthPercent := 100.000000000000000000;
    cbxapi_pix_excluido.DataField := 'api_pix.excluido';
    cbxapi_pix_excluido.DataSource := DataSource;
    edapi_pix_inclusao.SetParentComponent(Self);
    edapi_pix_inclusao.Name := 'edapi_pix_inclusao';
    edapi_pix_inclusao.Left := 373;
    edapi_pix_inclusao.Top := 464;
    edapi_pix_inclusao.Width := 120;
    edapi_pix_inclusao.Height := 21;
    edapi_pix_inclusao.ChildOrder := 43;
    edapi_pix_inclusao.Enabled := False;
    edapi_pix_inclusao.HeightPercent := 100.000000000000000000;
    edapi_pix_inclusao.TabOrder := 14;
    edapi_pix_inclusao.Text := 'edapi_pix_inclusao';
    edapi_pix_inclusao.WidthPercent := 100.000000000000000000;
    edapi_pix_inclusao.DataField := 'api_pix.inclusao';
    edapi_pix_inclusao.DataSource := DataSource;
    edapi_pix_alteracao.SetParentComponent(Self);
    edapi_pix_alteracao.Name := 'edapi_pix_alteracao';
    edapi_pix_alteracao.Left := 373;
    edapi_pix_alteracao.Top := 491;
    edapi_pix_alteracao.Width := 120;
    edapi_pix_alteracao.Height := 21;
    edapi_pix_alteracao.ChildOrder := 45;
    edapi_pix_alteracao.Enabled := False;
    edapi_pix_alteracao.HeightPercent := 100.000000000000000000;
    edapi_pix_alteracao.TabOrder := 15;
    edapi_pix_alteracao.Text := 'edapi_pix_alteracao';
    edapi_pix_alteracao.WidthPercent := 100.000000000000000000;
    edapi_pix_alteracao.DataField := 'api_pix.alteracao';
    edapi_pix_alteracao.DataSource := DataSource;
    edapi_pix_exclusao.SetParentComponent(Self);
    edapi_pix_exclusao.Name := 'edapi_pix_exclusao';
    edapi_pix_exclusao.Left := 373;
    edapi_pix_exclusao.Top := 518;
    edapi_pix_exclusao.Width := 120;
    edapi_pix_exclusao.Height := 21;
    edapi_pix_exclusao.ChildOrder := 46;
    edapi_pix_exclusao.Enabled := False;
    edapi_pix_exclusao.HeightPercent := 100.000000000000000000;
    edapi_pix_exclusao.TabOrder := 16;
    edapi_pix_exclusao.Text := 'edapi_pix_exclusao';
    edapi_pix_exclusao.WidthPercent := 100.000000000000000000;
    edapi_pix_exclusao.DataField := 'api_pix.exclusao';
    edapi_pix_exclusao.DataSource := DataSource;
    btnBaixarChavePrivada.SetParentComponent(Self);
    btnBaixarChavePrivada.Name := 'btnBaixarChavePrivada';
    btnBaixarChavePrivada.Left := 256;
    btnBaixarChavePrivada.Top := 596;
    btnBaixarChavePrivada.Width := 110;
    btnBaixarChavePrivada.Height := 25;
    btnBaixarChavePrivada.Caption := 'Baixar Chave Privada';
    btnBaixarChavePrivada.ChildOrder := 48;
    btnBaixarChavePrivada.HeightPercent := 100.000000000000000000;
    btnBaixarChavePrivada.TabOrder := 1;
    btnBaixarChavePrivada.WidthPercent := 100.000000000000000000;
    SetEvent(btnBaixarChavePrivada, Self, 'OnClick', 'btnBaixarChavePrivadaClick');
    btnBaixarCertificadoPem.SetParentComponent(Self);
    btnBaixarCertificadoPem.Name := 'btnBaixarCertificadoPem';
    btnBaixarCertificadoPem.Left := 374;
    btnBaixarCertificadoPem.Top := 596;
    btnBaixarCertificadoPem.Width := 119;
    btnBaixarCertificadoPem.Height := 25;
    btnBaixarCertificadoPem.Caption := 'Baixar Certificado PEM';
    btnBaixarCertificadoPem.ChildOrder := 49;
    btnBaixarCertificadoPem.HeightPercent := 100.000000000000000000;
    btnBaixarCertificadoPem.TabOrder := 1;
    btnBaixarCertificadoPem.WidthPercent := 100.000000000000000000;
    SetEvent(btnBaixarCertificadoPem, Self, 'OnClick', 'btnBaixarCertificadoPemClick');
    edchave_pix.SetParentComponent(Self);
    edchave_pix.Name := 'edchave_pix';
    edchave_pix.Left := 374;
    edchave_pix.Top := 545;
    edchave_pix.Width := 120;
    edchave_pix.Height := 21;
    edchave_pix.ChildOrder := 22;
    edchave_pix.Enabled := False;
    edchave_pix.HeightPercent := 100.000000000000000000;
    edchave_pix.TabOrder := 12;
    edchave_pix.Text := 'edchave_pix';
    edchave_pix.WidthPercent := 100.000000000000000000;
    edchave_pix.DataField := 'api_pix.chave_pix';
    edchave_pix.DataSource := DataSource;
    btnCopiarChavePix.SetParentComponent(Self);
    btnCopiarChavePix.Name := 'btnCopiarChavePix';
    btnCopiarChavePix.Left := 496;
    btnCopiarChavePix.Top := 545;
    btnCopiarChavePix.Width := 30;
    btnCopiarChavePix.Height := 21;
    btnCopiarChavePix.ChildOrder := 22;
    btnCopiarChavePix.HeightPercent := 100.000000000000000000;
    btnCopiarChavePix.WidthPercent := 100.000000000000000000;
    SetEvent(btnCopiarChavePix, Self, 'OnClick', 'btnCopiarChavePixClick');
    edstatus.SetParentComponent(Self);
    edstatus.Name := 'edstatus';
    edstatus.Left := 117;
    edstatus.Top := 319;
    edstatus.Width := 120;
    edstatus.Height := 21;
    edstatus.ChildOrder := 69;
    edstatus.Enabled := False;
    edstatus.HeightPercent := 100.000000000000000000;
    edstatus.TabOrder := 19;
    edstatus.Text := 'edstatus';
    edstatus.WidthPercent := 100.000000000000000000;
    edstatus.DataField := 'status';
    edstatus.DataSource := DataSource;
    edtipo_finalizar_venda.SetParentComponent(Self);
    edtipo_finalizar_venda.Name := 'edtipo_finalizar_venda';
    edtipo_finalizar_venda.Left := 373;
    edtipo_finalizar_venda.Top := 292;
    edtipo_finalizar_venda.Width := 120;
    edtipo_finalizar_venda.Height := 21;
    edtipo_finalizar_venda.ChildOrder := 69;
    edtipo_finalizar_venda.Enabled := False;
    edtipo_finalizar_venda.HeightPercent := 100.000000000000000000;
    edtipo_finalizar_venda.TabOrder := 19;
    edtipo_finalizar_venda.Text := 'edtipo_finalizar_venda';
    edtipo_finalizar_venda.WidthPercent := 100.000000000000000000;
    edtipo_finalizar_venda.DataField := 'tipo_finalizar_venda';
    edtipo_finalizar_venda.DataSource := DataSource;
    cbxpix_integrado.SetParentComponent(Self);
    cbxpix_integrado.Name := 'cbxpix_integrado';
    cbxpix_integrado.Left := 373;
    cbxpix_integrado.Top := 319;
    cbxpix_integrado.Width := 120;
    cbxpix_integrado.Height := 22;
    cbxpix_integrado.Caption := 'cbxpix_integrado';
    cbxpix_integrado.ChildOrder := 33;
    cbxpix_integrado.Enabled := False;
    cbxpix_integrado.HeightPercent := 100.000000000000000000;
    cbxpix_integrado.WidthPercent := 100.000000000000000000;
    cbxpix_integrado.DataField := 'pix_integrado';
    cbxpix_integrado.DataSource := DataSource;
    cbxmodalidade_web.SetParentComponent(Self);
    cbxmodalidade_web.Name := 'cbxmodalidade_web';
    cbxmodalidade_web.Left := 373;
    cbxmodalidade_web.Top := 346;
    cbxmodalidade_web.Width := 120;
    cbxmodalidade_web.Height := 22;
    cbxmodalidade_web.Caption := 'cbxmodalidade_web';
    cbxmodalidade_web.ChildOrder := 33;
    cbxmodalidade_web.Enabled := False;
    cbxmodalidade_web.HeightPercent := 100.000000000000000000;
    cbxmodalidade_web.WidthPercent := 100.000000000000000000;
    cbxmodalidade_web.DataField := 'modalidade_web';
    cbxmodalidade_web.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := ModalidadesDataset;
    DataSource.Left := 136;
    DataSource.Top := 352;
    ModalidadesDataset.SetParentComponent(Self);
    ModalidadesDataset.Name := 'ModalidadesDataset';
    ModalidadesDataset.AfterApplyUpdates := ModalidadesDatasetAfterApplyUpdates;
    ModalidadesDataset.EntitySetName := 'Modalidades';
    ModalidadesDataset.Connection := DMConnection.ApiConnection;
    ModalidadesDataset.Left := 40;
    ModalidadesDataset.Top := 352;
    ModalidadesDatasetid.SetParentComponent(ModalidadesDataset);
    ModalidadesDatasetid.Name := 'ModalidadesDatasetid';
    ModalidadesDatasetid.FieldName := 'id';
    ModalidadesDatasetid.Required := True;
    ModalidadesDatasetaliado_id.SetParentComponent(ModalidadesDataset);
    ModalidadesDatasetaliado_id.Name := 'ModalidadesDatasetaliado_id';
    ModalidadesDatasetaliado_id.FieldName := 'aliado_id';
    ModalidadesDatasetaliado_id.Required := True;
    ModalidadesDatasetdata_base_id.SetParentComponent(ModalidadesDataset);
    ModalidadesDatasetdata_base_id.Name := 'ModalidadesDatasetdata_base_id';
    ModalidadesDatasetdata_base_id.FieldName := 'data_base_id';
    ModalidadesDatasetdata_base_id.Required := True;
    ModalidadesDatasetconta_id.SetParentComponent(ModalidadesDataset);
    ModalidadesDatasetconta_id.Name := 'ModalidadesDatasetconta_id';
    ModalidadesDatasetconta_id.FieldName := 'conta_id';
    ModalidadesDatasetnome.SetParentComponent(ModalidadesDataset);
    ModalidadesDatasetnome.Name := 'ModalidadesDatasetnome';
    ModalidadesDatasetnome.FieldName := 'nome';
    ModalidadesDatasetnome.Required := True;
    ModalidadesDatasetnome.Size := 255;
    ModalidadesDatasetpermite_prazo.SetParentComponent(ModalidadesDataset);
    ModalidadesDatasetpermite_prazo.Name := 'ModalidadesDatasetpermite_prazo';
    ModalidadesDatasetpermite_prazo.FieldName := 'permite_prazo';
    ModalidadesDatasetpermite_prazo.Required := True;
    ModalidadesDatasetmodalidade_avista.SetParentComponent(ModalidadesDataset);
    ModalidadesDatasetmodalidade_avista.Name := 'ModalidadesDatasetmodalidade_avista';
    ModalidadesDatasetmodalidade_avista.FieldName := 'modalidade_avista';
    ModalidadesDatasetmodalidade_avista.Required := True;
    ModalidadesDatasetmodalidade_cheque_vinculado.SetParentComponent(ModalidadesDataset);
    ModalidadesDatasetmodalidade_cheque_vinculado.Name := 'ModalidadesDatasetmodalidade_cheque_vinculado';
    ModalidadesDatasetmodalidade_cheque_vinculado.FieldName := 'modalidade_cheque_vinculado';
    ModalidadesDatasetmodalidade_cheque_vinculado.Required := True;
    ModalidadesDatasetmodalidade_prazo_fixo.SetParentComponent(ModalidadesDataset);
    ModalidadesDatasetmodalidade_prazo_fixo.Name := 'ModalidadesDatasetmodalidade_prazo_fixo';
    ModalidadesDatasetmodalidade_prazo_fixo.FieldName := 'modalidade_prazo_fixo';
    ModalidadesDatasetmodalidade_prazo_fixo.Required := True;
    ModalidadesDatasetmodalidade_pagamento_digital.SetParentComponent(ModalidadesDataset);
    ModalidadesDatasetmodalidade_pagamento_digital.Name := 'ModalidadesDatasetmodalidade_pagamento_digital';
    ModalidadesDatasetmodalidade_pagamento_digital.FieldName := 'modalidade_pagamento_digital';
    ModalidadesDatasetmodalidade_pagamento_digital.Required := True;
    ModalidadesDatasetmodalidade_pix.SetParentComponent(ModalidadesDataset);
    ModalidadesDatasetmodalidade_pix.Name := 'ModalidadesDatasetmodalidade_pix';
    ModalidadesDatasetmodalidade_pix.FieldName := 'modalidade_pix';
    ModalidadesDatasetmodalidade_pix.Required := True;
    ModalidadesDatasetmodalidade_cartao.SetParentComponent(ModalidadesDataset);
    ModalidadesDatasetmodalidade_cartao.Name := 'ModalidadesDatasetmodalidade_cartao';
    ModalidadesDatasetmodalidade_cartao.FieldName := 'modalidade_cartao';
    ModalidadesDatasetmodalidade_cartao.Required := True;
    ModalidadesDatasettipo_cartao.SetParentComponent(ModalidadesDataset);
    ModalidadesDatasettipo_cartao.Name := 'ModalidadesDatasettipo_cartao';
    ModalidadesDatasettipo_cartao.FieldName := 'tipo_cartao';
    SetEvent(ModalidadesDatasettipo_cartao, Self, 'OnGetText', 'ModalidadesDatasettipo_cartaoGetText');
    ModalidadesDatasetcomissao.SetParentComponent(ModalidadesDataset);
    ModalidadesDatasetcomissao.Name := 'ModalidadesDatasetcomissao';
    ModalidadesDatasetcomissao.FieldName := 'comissao';
    ModalidadesDatasetcomissao.DisplayFormat := '#,##0.000';
    ModalidadesDatasetprazo_dias.SetParentComponent(ModalidadesDataset);
    ModalidadesDatasetprazo_dias.Name := 'ModalidadesDatasetprazo_dias';
    ModalidadesDatasetprazo_dias.FieldName := 'prazo_dias';
    ModalidadesDatasetdia_fixo.SetParentComponent(ModalidadesDataset);
    ModalidadesDatasetdia_fixo.Name := 'ModalidadesDatasetdia_fixo';
    ModalidadesDatasetdia_fixo.FieldName := 'dia_fixo';
    ModalidadesDatasetparcela_minima.SetParentComponent(ModalidadesDataset);
    ModalidadesDatasetparcela_minima.Name := 'ModalidadesDatasetparcela_minima';
    ModalidadesDatasetparcela_minima.FieldName := 'parcela_minima';
    ModalidadesDatasetquantidade_parcelas.SetParentComponent(ModalidadesDataset);
    ModalidadesDatasetquantidade_parcelas.Name := 'ModalidadesDatasetquantidade_parcelas';
    ModalidadesDatasetquantidade_parcelas.FieldName := 'quantidade_parcelas';
    ModalidadesDatasettag_pagamento.SetParentComponent(ModalidadesDataset);
    ModalidadesDatasettag_pagamento.Name := 'ModalidadesDatasettag_pagamento';
    ModalidadesDatasettag_pagamento.FieldName := 'tag_pagamento';
    ModalidadesDatasettag_pagamento.Size := 255;
    ModalidadesDatasetcodigo_interno.SetParentComponent(ModalidadesDataset);
    ModalidadesDatasetcodigo_interno.Name := 'ModalidadesDatasetcodigo_interno';
    ModalidadesDatasetcodigo_interno.FieldName := 'codigo_interno';
    ModalidadesDatasetcodigo_interno.Required := True;
    ModalidadesDatasetexcluido.SetParentComponent(ModalidadesDataset);
    ModalidadesDatasetexcluido.Name := 'ModalidadesDatasetexcluido';
    ModalidadesDatasetexcluido.FieldName := 'excluido';
    ModalidadesDatasetinclusao.SetParentComponent(ModalidadesDataset);
    ModalidadesDatasetinclusao.Name := 'ModalidadesDatasetinclusao';
    ModalidadesDatasetinclusao.FieldName := 'inclusao';
    ModalidadesDatasetinclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    ModalidadesDatasetalteracao.SetParentComponent(ModalidadesDataset);
    ModalidadesDatasetalteracao.Name := 'ModalidadesDatasetalteracao';
    ModalidadesDatasetalteracao.FieldName := 'alteracao';
    ModalidadesDatasetalteracao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    ModalidadesDatasetexclusao.SetParentComponent(ModalidadesDataset);
    ModalidadesDatasetexclusao.Name := 'ModalidadesDatasetexclusao';
    ModalidadesDatasetexclusao.FieldName := 'exclusao';
    ModalidadesDatasetexclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    ModalidadesDatasetapi_pixcodigo_interno.SetParentComponent(ModalidadesDataset);
    ModalidadesDatasetapi_pixcodigo_interno.Name := 'ModalidadesDatasetapi_pixcodigo_interno';
    ModalidadesDatasetapi_pixcodigo_interno.FieldName := 'api_pix.codigo_interno';
    ModalidadesDatasetapi_pixclient_id.SetParentComponent(ModalidadesDataset);
    ModalidadesDatasetapi_pixclient_id.Name := 'ModalidadesDatasetapi_pixclient_id';
    ModalidadesDatasetapi_pixclient_id.FieldName := 'api_pix.client_id';
    ModalidadesDatasetapi_pixclient_secret.SetParentComponent(ModalidadesDataset);
    ModalidadesDatasetapi_pixclient_secret.Name := 'ModalidadesDatasetapi_pixclient_secret';
    ModalidadesDatasetapi_pixclient_secret.FieldName := 'api_pix.client_secret';
    ModalidadesDatasetapi_pixdeveloper_key.SetParentComponent(ModalidadesDataset);
    ModalidadesDatasetapi_pixdeveloper_key.Name := 'ModalidadesDatasetapi_pixdeveloper_key';
    ModalidadesDatasetapi_pixdeveloper_key.FieldName := 'api_pix.developer_key';
    ModalidadesDatasetapi_pixid.SetParentComponent(ModalidadesDataset);
    ModalidadesDatasetapi_pixid.Name := 'ModalidadesDatasetapi_pixid';
    ModalidadesDatasetapi_pixid.FieldName := 'api_pix.id';
    ModalidadesDatasetapi_pixexcluido.SetParentComponent(ModalidadesDataset);
    ModalidadesDatasetapi_pixexcluido.Name := 'ModalidadesDatasetapi_pixexcluido';
    ModalidadesDatasetapi_pixexcluido.FieldName := 'api_pix.excluido';
    ModalidadesDatasetapi_pixinclusao.SetParentComponent(ModalidadesDataset);
    ModalidadesDatasetapi_pixinclusao.Name := 'ModalidadesDatasetapi_pixinclusao';
    ModalidadesDatasetapi_pixinclusao.FieldName := 'api_pix.inclusao';
    ModalidadesDatasetapi_pixinclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    ModalidadesDatasetapi_pixalteracao.SetParentComponent(ModalidadesDataset);
    ModalidadesDatasetapi_pixalteracao.Name := 'ModalidadesDatasetapi_pixalteracao';
    ModalidadesDatasetapi_pixalteracao.FieldName := 'api_pix.alteracao';
    ModalidadesDatasetapi_pixalteracao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    ModalidadesDatasetapi_pixexclusao.SetParentComponent(ModalidadesDataset);
    ModalidadesDatasetapi_pixexclusao.Name := 'ModalidadesDatasetapi_pixexclusao';
    ModalidadesDatasetapi_pixexclusao.FieldName := 'api_pix.exclusao';
    ModalidadesDatasetapi_pixexclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    ModalidadesDatasetapi_pixchave_pix.SetParentComponent(ModalidadesDataset);
    ModalidadesDatasetapi_pixchave_pix.Name := 'ModalidadesDatasetapi_pixchave_pix';
    ModalidadesDatasetapi_pixchave_pix.FieldName := 'api_pix.chave_pix';
    ModalidadesDatasetpix_integrado.SetParentComponent(ModalidadesDataset);
    ModalidadesDatasetpix_integrado.Name := 'ModalidadesDatasetpix_integrado';
    ModalidadesDatasetpix_integrado.FieldName := 'pix_integrado';
    ModalidadesDatasetpix_integrado.Required := True;
    ModalidadesDatasettipo_finalizar_venda.SetParentComponent(ModalidadesDataset);
    ModalidadesDatasettipo_finalizar_venda.Name := 'ModalidadesDatasettipo_finalizar_venda';
    ModalidadesDatasettipo_finalizar_venda.FieldName := 'tipo_finalizar_venda';
    SetEvent(ModalidadesDatasettipo_finalizar_venda, Self, 'OnGetText', 'ModalidadesDatasettipo_finalizar_vendaGetText');
    ModalidadesDatasetstatus.SetParentComponent(ModalidadesDataset);
    ModalidadesDatasetstatus.Name := 'ModalidadesDatasetstatus';
    ModalidadesDatasetstatus.FieldName := 'status';
    SetEvent(ModalidadesDatasetstatus, Self, 'OnGetText', 'ModalidadesDatasetstatusGetText');
    ModalidadesDatasetmodalidade_web.SetParentComponent(ModalidadesDataset);
    ModalidadesDatasetmodalidade_web.Name := 'ModalidadesDatasetmodalidade_web';
    ModalidadesDatasetmodalidade_web.FieldName := 'modalidade_web';
    XDataClientModalidadesGet.SetParentComponent(Self);
    XDataClientModalidadesGet.Name := 'XDataClientModalidadesGet';
    XDataClientModalidadesGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientModalidadesGet, Self, 'OnLoad', 'XDataClientModalidadesGetLoad');
    XDataClientModalidadesGet.Left := 181;
    XDataClientModalidadesGet.Top := 352;
    XDataWebClientBaixarArquivos.SetParentComponent(Self);
    XDataWebClientBaixarArquivos.Name := 'XDataWebClientBaixarArquivos';
    XDataWebClientBaixarArquivos.Connection := DMConnection.ApiConnection;
    SetEvent(XDataWebClientBaixarArquivos, Self, 'OnLoad', 'XDataWebClientBaixarArquivosLoad');
    SetEvent(XDataWebClientBaixarArquivos, Self, 'OnError', 'XDataWebClientBaixarArquivosError');
    XDataWebClientBaixarArquivos.Left := 104;
    XDataWebClientBaixarArquivos.Top := 600;
  finally
    lbid.AfterLoadDFMValues;
    lbnome.AfterLoadDFMValues;
    lbpermite_prazo.AfterLoadDFMValues;
    lbmodalidade_avista.AfterLoadDFMValues;
    lbmodalidade_cheque_vinculado.AfterLoadDFMValues;
    lbmodalidade_prazo_fixo.AfterLoadDFMValues;
    lbmodalidade_pagamento_digital.AfterLoadDFMValues;
    lbmodalidade_pix.AfterLoadDFMValues;
    lbmodalidade_cartao.AfterLoadDFMValues;
    lbtipo_cartao.AfterLoadDFMValues;
    lbcomissao.AfterLoadDFMValues;
    lbprazo_dias.AfterLoadDFMValues;
    lbdia_fixo.AfterLoadDFMValues;
    lbparcela_minima.AfterLoadDFMValues;
    lbquantidade_parcelas.AfterLoadDFMValues;
    lbtag_pagamento.AfterLoadDFMValues;
    lbcodigo_interno.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    lbapi_pix_id.AfterLoadDFMValues;
    lbapi_pix_codigo_interno.AfterLoadDFMValues;
    lbclient_id.AfterLoadDFMValues;
    lbclient_secret.AfterLoadDFMValues;
    lbdeveloper_key.AfterLoadDFMValues;
    lbapi_pix_excluido.AfterLoadDFMValues;
    lbapi_pix_inclusao.AfterLoadDFMValues;
    lbapi_pix_alteracao.AfterLoadDFMValues;
    lbapi_pix_exclusao.AfterLoadDFMValues;
    lbchave_pix.AfterLoadDFMValues;
    lbstatus.AfterLoadDFMValues;
    lbtipo_finalizar_venda.AfterLoadDFMValues;
    lbpix_integrado.AfterLoadDFMValues;
    lbmodalidade_web.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    ednome.AfterLoadDFMValues;
    edtipo_cartao.AfterLoadDFMValues;
    edcomissao.AfterLoadDFMValues;
    edprazo_dias.AfterLoadDFMValues;
    eddia_fixo.AfterLoadDFMValues;
    edparcela_minima.AfterLoadDFMValues;
    edquantidade_parcelas.AfterLoadDFMValues;
    edtag_pagamento.AfterLoadDFMValues;
    edcodigo_interno.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    pnlDadosModalidade.AfterLoadDFMValues;
    cbxpermite_prazo.AfterLoadDFMValues;
    cbxmodalidade_avista.AfterLoadDFMValues;
    cbxmodalidade_cheque_vinculado.AfterLoadDFMValues;
    cbxmodalidade_prazo_fixo.AfterLoadDFMValues;
    cbxmodalidade_pagamento_digital.AfterLoadDFMValues;
    modalidade_pix.AfterLoadDFMValues;
    cbxmodalidade_cartao.AfterLoadDFMValues;
    cbxexcluido.AfterLoadDFMValues;
    pnlDadosSincronizacaoAutomatica.AfterLoadDFMValues;
    edapi_pix_id.AfterLoadDFMValues;
    edapi_pix_codigo_interno.AfterLoadDFMValues;
    edclient_id.AfterLoadDFMValues;
    edclient_secret.AfterLoadDFMValues;
    eddeveloper_key.AfterLoadDFMValues;
    cbxapi_pix_excluido.AfterLoadDFMValues;
    edapi_pix_inclusao.AfterLoadDFMValues;
    edapi_pix_alteracao.AfterLoadDFMValues;
    edapi_pix_exclusao.AfterLoadDFMValues;
    btnBaixarChavePrivada.AfterLoadDFMValues;
    btnBaixarCertificadoPem.AfterLoadDFMValues;
    edchave_pix.AfterLoadDFMValues;
    btnCopiarChavePix.AfterLoadDFMValues;
    edstatus.AfterLoadDFMValues;
    edtipo_finalizar_venda.AfterLoadDFMValues;
    cbxpix_integrado.AfterLoadDFMValues;
    cbxmodalidade_web.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    ModalidadesDataset.AfterLoadDFMValues;
    ModalidadesDatasetid.AfterLoadDFMValues;
    ModalidadesDatasetaliado_id.AfterLoadDFMValues;
    ModalidadesDatasetdata_base_id.AfterLoadDFMValues;
    ModalidadesDatasetconta_id.AfterLoadDFMValues;
    ModalidadesDatasetnome.AfterLoadDFMValues;
    ModalidadesDatasetpermite_prazo.AfterLoadDFMValues;
    ModalidadesDatasetmodalidade_avista.AfterLoadDFMValues;
    ModalidadesDatasetmodalidade_cheque_vinculado.AfterLoadDFMValues;
    ModalidadesDatasetmodalidade_prazo_fixo.AfterLoadDFMValues;
    ModalidadesDatasetmodalidade_pagamento_digital.AfterLoadDFMValues;
    ModalidadesDatasetmodalidade_pix.AfterLoadDFMValues;
    ModalidadesDatasetmodalidade_cartao.AfterLoadDFMValues;
    ModalidadesDatasettipo_cartao.AfterLoadDFMValues;
    ModalidadesDatasetcomissao.AfterLoadDFMValues;
    ModalidadesDatasetprazo_dias.AfterLoadDFMValues;
    ModalidadesDatasetdia_fixo.AfterLoadDFMValues;
    ModalidadesDatasetparcela_minima.AfterLoadDFMValues;
    ModalidadesDatasetquantidade_parcelas.AfterLoadDFMValues;
    ModalidadesDatasettag_pagamento.AfterLoadDFMValues;
    ModalidadesDatasetcodigo_interno.AfterLoadDFMValues;
    ModalidadesDatasetexcluido.AfterLoadDFMValues;
    ModalidadesDatasetinclusao.AfterLoadDFMValues;
    ModalidadesDatasetalteracao.AfterLoadDFMValues;
    ModalidadesDatasetexclusao.AfterLoadDFMValues;
    ModalidadesDatasetapi_pixcodigo_interno.AfterLoadDFMValues;
    ModalidadesDatasetapi_pixclient_id.AfterLoadDFMValues;
    ModalidadesDatasetapi_pixclient_secret.AfterLoadDFMValues;
    ModalidadesDatasetapi_pixdeveloper_key.AfterLoadDFMValues;
    ModalidadesDatasetapi_pixid.AfterLoadDFMValues;
    ModalidadesDatasetapi_pixexcluido.AfterLoadDFMValues;
    ModalidadesDatasetapi_pixinclusao.AfterLoadDFMValues;
    ModalidadesDatasetapi_pixalteracao.AfterLoadDFMValues;
    ModalidadesDatasetapi_pixexclusao.AfterLoadDFMValues;
    ModalidadesDatasetapi_pixchave_pix.AfterLoadDFMValues;
    ModalidadesDatasetpix_integrado.AfterLoadDFMValues;
    ModalidadesDatasettipo_finalizar_venda.AfterLoadDFMValues;
    ModalidadesDatasetstatus.AfterLoadDFMValues;
    ModalidadesDatasetmodalidade_web.AfterLoadDFMValues;
    XDataClientModalidadesGet.AfterLoadDFMValues;
    XDataWebClientBaixarArquivos.AfterLoadDFMValues;
  end;
end;

end.
